
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { IUserDeptInfo } from '@/api/types'
import EmptyState from '@/components/Empty/EmptyState.vue'

@Component({
  components: {
    EmptyState
}})
export default class UserDepartmentsCard extends Vue {

  public get depts(): IUserDeptInfo[] {
    if (UserModule.userInfo && UserModule.depts) {
      console.log("depts:", UserModule.depts)
      return UserModule.depts
    } else {
      return []
    }
  }

  // 处理部门点击事件
  public handleDeptClick(dept: IUserDeptInfo) {
    // console.log('部门被点击:', dept)
    // 预留跳转逻辑，后续实现
    // this.$router.push({ path: `/department/${dept.id}` })
  }
}
